import { makeRequest } from 'utils/requestLogger';

const joinFirstLrtInCourse = (course_id, user_id) =>
  makeRequest(
    'put',
    `api/courses/${course_id}/participants/${user_id}/has_joined_first_live_discussion`
  );

export default joinFirstLrtInCourse;



// WEBPACK FOOTER //
// ./src/app/services/courses/joinFirstLrtInCourse.js